module.exports = __webpack_public_path__ + "img/160419724814650_thumbnail.jpg";